import { Box } from "@mui/material"
import type { FC } from "react"
import { useMemo } from "react"

import type { PurchasingCostsByWarehouse } from "../../types"

import { formatWarehouseLabel } from "./purchaseCostLabels"

import { AerosMultiAutocomplete } from "@/components/UiKit/AerosMultiAutocomplete"
import type { Option } from "@/types/form-fields"

interface PurchaseCostsWarehouseFilterProps {
  warehouses: PurchasingCostsByWarehouse[]
  selectedWarehouseIds: string[]
  onChange: (selectedIds: string[]) => void
}

export const PurchaseCostsWarehouseFilter: FC<PurchaseCostsWarehouseFilterProps> = ({
  warehouses,
  selectedWarehouseIds,
  onChange,
}) => {
  const options = useMemo<Option<string>[]>(
    () =>
      warehouses.map((warehouse) => ({
        value: warehouse.warehouseAreaId,
        label: formatWarehouseLabel(warehouse.location),
      })),
    [warehouses]
  )

  return (
    <Box className='max-w-[500px]'>
      <AerosMultiAutocomplete
        options={options}
        value={selectedWarehouseIds}
        onChange={onChange}
        placeholder='Select warehouse'
        data-testid='product.purchase-costs.warehouse-filter'
      />
    </Box>
  )
}
